export default "__VITE_ASSET__8kmtFrW___"